import { render, staticRenderFns } from "./RateTabPanel.vue?vue&type=template&id=577f6920&"
import script from "./RateTabPanel.vue?vue&type=script&lang=ts&"
export * from "./RateTabPanel.vue?vue&type=script&lang=ts&"
import style0 from "./RateTabPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports